var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3781_26184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3751 2C21.5334 2 21.6959 2.06249 21.8167 2.18333C22.0626 2.42916 22.0626 2.825 21.8167 3.06666L3.06672 21.8167C2.82089 22.0625 2.42506 22.0625 2.18339 21.8167C1.93756 21.5708 1.93756 21.175 2.18339 20.9333L20.9334 2.18333C21.0542 2.06249 21.2167 2 21.3751 2Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.62506 1.99999C2.78339 1.99999 2.94589 2.06249 3.06673 2.18333L21.8167 20.9333C22.0626 21.175 22.0626 21.575 21.8167 21.8167C21.5709 22.0625 21.1792 22.0625 20.9334 21.8167L2.18339 3.06666C1.93756 2.82083 1.93756 2.42499 2.18339 2.18333C2.30423 2.06249 2.46673 1.99999 2.62506 1.99999Z",
    fill: "#194142"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3781_26184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(22 22) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.8ad54fb8411ac3cbdb7d27e1c9ed4278.svg";
export { ForwardRef as ReactComponent };